import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedRoute = () => {
  const hasToken = !!Cookies.get('accessToken'); // Check if token exists in cookies

  return hasToken ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
